import script from "./StopsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StopsTable.vue?vue&type=script&setup=true&lang=js"

import "./StopsTable.vue?vue&type=style&index=0&id=7c71fc42&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c71fc42"]])

export default __exports__